import React, {useEffect, useState} from "react";
import {Container, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import Service from "../services/Service";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from '@material-ui/lab/Alert';
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Tooltip from "@material-ui/core/Tooltip";
import Box from "@material-ui/core/Box";
import {DOMEN} from "../services/domen";

const service = new Service();

const Alert = (props) => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(2),
    },
    tokenText: {
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '0.85rem',
        wordBreak: 'break-all',
    },
    infoBox: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: '#F4F6FA',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #E8ECF2',
    },
    codeBlock: {
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '0.8rem',
        backgroundColor: theme.palette.grey[100],
        padding: theme.spacing(1.5),
        borderRadius: theme.shape.borderRadius,
        overflowX: 'auto',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-all',
    },
    newTokenBox: {
        marginTop: theme.spacing(1),
        padding: theme.spacing(2),
        backgroundColor: '#FFFBEB',
        borderRadius: theme.shape.borderRadius,
        border: '1px solid #F59E0B',
    },
    newTokenText: {
        fontFamily: '"JetBrains Mono", monospace',
        fontSize: '0.9rem',
        wordBreak: 'break-all',
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        borderRadius: 4,
        border: '1px solid #ddd',
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    dateCell: {
        whiteSpace: 'nowrap',
        fontSize: '0.85rem',
        color: theme.palette.text.secondary,
    },
}));

export default function MCPTokens() {
    const classes = useStyles();
    const [tokens, setTokens] = useState([]);
    const [loading, setLoading] = useState(true);

    // Create dialog
    const [createOpen, setCreateOpen] = useState(false);
    const [newName, setNewName] = useState('');

    // New token display dialog
    const [newTokenOpen, setNewTokenOpen] = useState(false);
    const [newToken, setNewToken] = useState('');

    // Delete confirmation dialog
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [deleteTarget, setDeleteTarget] = useState(null);

    // Snackbar
    const [alert, setAlert] = useState({open: false, message: '', severity: 'success'});

    const fetchTokens = () => {
        setLoading(true);
        service.getMCPTokens()
            .then(res => {
                setTokens(res.data);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        fetchTokens();
    }, []);

    // Create token
    const handleCreate = () => {
        service.createMCPToken({name: newName || 'MCP Token'})
            .then(res => {
                setCreateOpen(false);
                setNewName('');
                setNewToken(res.data.token);
                setNewTokenOpen(true);
                fetchTokens();
            })
            .catch(err => {
                const msg = err.response?.data?.error || 'Ошибка создания токена';
                setAlert({open: true, message: msg, severity: 'error'});
            });
    };

    // Copy to clipboard
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setAlert({open: true, message: 'Скопировано', severity: 'success'});
        });
    };

    // Delete token
    const handleDelete = () => {
        if (!deleteTarget) return;
        service.deleteMCPToken(deleteTarget.id)
            .then(() => {
                setDeleteOpen(false);
                setDeleteTarget(null);
                setAlert({open: true, message: 'Токен отозван', severity: 'success'});
                fetchTokens();
            })
            .catch(() => {
                setAlert({open: true, message: 'Ошибка удаления', severity: 'error'});
            });
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        return d.toLocaleDateString('ru-RU') + ' ' + d.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'});
    };

    const mcpUrl = DOMEN.replace('http://localhost:8000', 'https://rest.investmonitoring.ru');

    return (
        <Container maxWidth="md" className={classes.root}>
            <div className={classes.header}>
                <div>
                    <Typography variant="h5">AI-интеграции</Typography>
                    <Typography variant="body2" color="textSecondary">
                        Токены для подключения AI-клиентов (Claude, Cursor, ChatGPT)
                    </Typography>
                </div>
                <Button variant="contained" onClick={() => setCreateOpen(true)} style={{backgroundColor: '#3B82F6', color: '#fff'}}>
                    + Новый токен
                </Button>
            </div>

            {/* Token table */}
            <TableContainer component={Paper}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Название</TableCell>
                            <TableCell>Токен</TableCell>
                            <TableCell>Последнее использование</TableCell>
                            <TableCell>IP</TableCell>
                            <TableCell align="right">Действия</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!loading && tokens.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    <Typography variant="body2" color="textSecondary" style={{padding: 16}}>
                                        Нет подключенных AI-клиентов. Создайте токен для Claude Desktop, Cursor или ChatGPT.
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {tokens.map(token => (
                            <TableRow key={token.id}>
                                <TableCell>{token.name || 'MCP Token'}</TableCell>
                                <TableCell>
                                    <span className={classes.tokenText}>{token.token}</span>
                                </TableCell>
                                <TableCell className={classes.dateCell}>
                                    {formatDate(token.last_used)}
                                </TableCell>
                                <TableCell className={classes.dateCell}>
                                    {token.last_ip || '—'}
                                </TableCell>
                                <TableCell align="right">
                                    <Tooltip title="Отозвать токен">
                                        <IconButton
                                            size="small"
                                            onClick={() => {
                                                setDeleteTarget(token);
                                                setDeleteOpen(true);
                                            }}
                                        >
                                            <DeleteIcon fontSize="small"/>
                                        </IconButton>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Connection instructions */}
            <Box className={classes.infoBox}>
                <Typography variant="subtitle2" gutterBottom>
                    Как подключить?
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    Добавьте в настройки MCP-клиента (например, <code>~/.claude/claude_desktop_config.json</code>):
                </Typography>
                <Box className={classes.codeBlock}>
{`{
  "mcpServers": {
    "investmonitoring": {
      "url": "${mcpUrl}/mcp/{ваш_токен}/mcp"
    }
  }
}`}
                </Box>
                <Typography variant="caption" color="textSecondary" style={{marginTop: 8, display: 'block'}}>
                    Замените <code>{'{ваш_токен}'}</code> на полный токен (im_...), который показывается при создании.
                </Typography>
            </Box>

            {/* Create dialog */}
            <Dialog open={createOpen} onClose={() => setCreateOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Новый токен для AI-клиента</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="Название (например, Claude Desktop, Cursor)"
                        fullWidth
                        value={newName}
                        onChange={e => setNewName(e.target.value)}
                        placeholder="Claude Desktop"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setCreateOpen(false)}>Отмена</Button>
                    <Button onClick={handleCreate} color="primary" variant="contained">
                        Создать
                    </Button>
                </DialogActions>
            </Dialog>

            {/* New token display dialog */}
            <Dialog open={newTokenOpen} onClose={() => setNewTokenOpen(false)} maxWidth="sm" fullWidth>
                <DialogTitle>Токен создан</DialogTitle>
                <DialogContent>
                    <Box className={classes.newTokenBox}>
                        <Typography variant="body2" style={{fontWeight: 600}}>
                            Скопируйте токен сейчас. Он больше не будет показан полностью!
                        </Typography>
                        <Box className={classes.newTokenText}>
                            {newToken}
                        </Box>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<FileCopyOutlinedIcon/>}
                            onClick={() => handleCopy(newToken)}
                        >
                            Копировать токен
                        </Button>
                    </Box>

                    <Box style={{marginTop: 16}}>
                        <Typography variant="body2" color="textSecondary">
                            URL для подключения:
                        </Typography>
                        <Box className={classes.codeBlock} style={{marginTop: 8}}>
                            {`${mcpUrl}/mcp/${newToken}/mcp`}
                        </Box>
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<FileCopyOutlinedIcon/>}
                            onClick={() => handleCopy(`${mcpUrl}/mcp/${newToken}/mcp`)}
                            style={{marginTop: 8}}
                        >
                            Копировать URL
                        </Button>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setNewTokenOpen(false)} color="primary" variant="contained">
                        Готово
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Delete confirmation dialog */}
            <Dialog open={deleteOpen} onClose={() => setDeleteOpen(false)}>
                <DialogTitle>Отозвать токен?</DialogTitle>
                <DialogContent>
                    <Typography variant="body2">
                        Токен <b>{deleteTarget?.name || 'MCP Token'}</b> будет деактивирован.
                        Все клиенты, использующие этот токен, потеряют доступ.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setDeleteOpen(false)}>Отмена</Button>
                    <Button onClick={handleDelete} color="secondary" variant="contained">
                        Отозвать
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Snackbar */}
            <Snackbar
                open={alert.open}
                autoHideDuration={3000}
                onClose={() => setAlert({...alert, open: false})}
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            >
                <Alert onClose={() => setAlert({...alert, open: false})} severity={alert.severity}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
